export const ua = window.navigator.userAgent.toLowerCase();

// 是否为移动端, 增加鸿蒙手机系统
export const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Phone|Mobile/i.test(ua);

// 是否为移动安卓端
export const isAndroid = /Android/i.test(ua);

// 是否为移动IOS端
export const isIOS = /iPhone|iPad|iPod/i.test(ua);

// 是否为鸿蒙系统
export const isHarmonyOS = /HarmonyOS|Phone/i.test(ua);

// 是否为非移动端
export const isNotMobile = !isMobile;

// 是否为PC客户端应用程序（PC客户端终端）
export const isPcClient = isNotMobile && /minxingmessenger/.test(ua);

// 是否为PC web浏览器端
export const isWebBrowser = isNotMobile && !isPcClient;

// 是否为PC mac系统
export const isMacintosh = /Macintosh/i.test(ua);

// 是否为PC windows系统
export const isWindows = /Windows/i.test(ua);

// 是否IE
export const isIE = /MSIE/gi.test(ua);

// 是否IE6
export const isIE6 = /MSIE 6.0/gi.test(ua);

// 是否为微信
export const isWechat = !!ua.match(/micromessenger/i);

// 是否为微博
export const isWeibo = !!ua.match(/weibo/);

// 是否为QQ
export const isQQ = !!ua.match(/qq/i);

// 是否为QQ浏览器
export const isMqqBrower = !!ua.match(/mqqbrower/);

// 是否为支付宝
export const isAlipay = !!ua.match(/alipay/i);

// 是否为钉钉
export const isDingtalk = !!ua.match(/dingtalk/i);

// 是否百度客户端
export const isBaidu = !!ua.match(/baidu/i);

// 是否为Safari浏览器
export const isSafari = /Safari/gi.test(ua) && !/Chrome/gi.test(ua);
